module.exports = __webpack_public_path__ + "img/init.aac92aaf.svg";